import { paths } from 'src/paths';

export const getDefaultPath = (user) => {
  if (!user) return paths.index;
  if (user.is_super) return paths.dashboard.admin;
  if (user.role === 'garante') return paths.dashboard.operaciones.tablero;
  if (user.role === 'inversionista') return paths.dashboard.inversionista.dashboard;
  if (user.role === 'pyme') return paths.dashboard.pyme.dashboard;
  return paths.index;
};
